export default __webpack_public_path__ + "static/media/tewodros.b8585648.jpg";